<template>
  <div class="circle" :class="{active: isActive}" v-click-outside="cancel">
    <img :src="getImgUrl(employee.imageName)" />
    <div class="info">
      <div class="headline-6">{{employee.name}}</div>
      <div class="headline-7">{{employee.title}}</div>
      <div
        class="description" v-if="employee.description"
      >{{employee.description}}</div>
      <div class="linkedin" @click="cancel">
        <a :href="employee.linkedinURL" target="_blank" v-if="employee.linkedinURL">
          <img src="../assets/linkedin.png" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    employee: Object
  },
  data () {
    return {
      isActive: false
    }
  },
  methods: {
    toogleActive () {
      this.isActive = !this.isActive
    },
    cancel () {
      this.isActive = false
    },
    getImgUrl (name) {
      let images = require.context('../assets/team/', false, /\.png$/)
      return images('./' + name + '.png')
    }
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MemberProfile.vue